import {createElement, Component, PropTypes} from 'rlink-react';
import contentLoader from 'helpers/content-loader';
import {ContentImg} from 'rlink-repos/content-components';
import css from 'static/style/dow.less';
import {NavLink} from 'rlink-router/component';

export default class UnitRevealCard extends Component {
  render () {
    if (this.props.articleSlug) {
      return (
        <NavLink className={css['unit-widget']} href={{
          view: 'article',
          params: {slug: this.props.articleSlug},
        }}>
          {this.renderCard()}
        </NavLink>);
    } else {
      return this.renderCard(css['unit-widget']);
    }
  }

  renderCard (className) {
    return (
      <div className={className}>
        <header>
          <h3>{this.props.title}</h3>
        </header>
        <div className={css.content}>
          <ContentImg src={this.props.imagePath} />
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/unit-reveal-card.jsx